import { render, staticRenderFns } from "./EcodemolizioniTest.vue?vue&type=template&id=79156b23&scoped=true&"
import script from "./EcodemolizioniTest.vue?vue&type=script&lang=js&"
export * from "./EcodemolizioniTest.vue?vue&type=script&lang=js&"
import style0 from "./EcodemolizioniTest.vue?vue&type=style&index=0&id=79156b23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79156b23",
  null
  
)

export default component.exports